import React from 'react'
import { Box, CircularProgress } from '@mui/material'

const FullScreenLoading: React.FC = () => {
  return (
    <Box
      sx={{
        width: '100vw',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <CircularProgress size={50} />
    </Box>
  )
}

export default FullScreenLoading
